var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-breadcrumb',{attrs:{"items":_vm.getLista()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }